import React, { Component, useEffect, useState } from "react";
import { Radio, Row, Col } from "antd";

import { parseFormControlValue, isAllowedValue } from "../../../services/utils";
import styles from "./singleSelector.scss";

const SingleSelector = props => {
  const { options, title, isRequired, field, onChange, value } = props;

  const getValueState = () => {
    return {
      value: value && isAllowedValue(value[field]) ? value[field] : ""
    };
  };

  const [state, setState] = useState(getValueState());

  const handleChange = newValue => {
    setState({
      value: newValue
    });

    onChange(parseFormControlValue([field], [newValue]));

  }

  useEffect(() => {
    // Apply the form.json `selected: true` default whenever one is set,
    // not only for required radios. The isRequired gate used to block
    // optional radios like V2OGLASI-2648's locationScope from picking up
    // their configured default (Točna lokacija).
    if (!getValueState().value) {
      const foundDefaultOption = options.find(o => o.selected)
      if (foundDefaultOption) {
        handleChange(foundDefaultOption.value)
      }
    }
  }, []);


  useEffect(() => {
    setState(getValueState());
  }, [JSON.stringify(props.value)]);

  const onRadioValueChange = e => {
    const newValue = e.target.value;
    handleChange(newValue)
  };

  return (
    <React.Fragment>
      {title ? <span className="control-title">{title}</span> : null}
      <Radio.Group
        onChange={onRadioValueChange}
        value={state.value}
        className={`${styles.radioGroup} ${field === "rentPriceType" ? styles.rentPriceTypeRadioGroup : ""}`}
      >
        <Row type="flex" align="middle">
          {options.map((option, index) => (
            <Col
              key={index /* eslint-disable-line */}
              xs={field === "rentPriceType" ? 12 : 24}
              lg={field === "locationScope" ? 6 : 12}
              className={styles.radioBtnWrapper}
            >
              <Radio value={option.value}>
                {option.title}
              </Radio>
            </Col>
          ))}
        </Row>
      </Radio.Group>
    </React.Fragment>
  );
};

SingleSelector.defaultProps = {
  options: [],
  title: ""
};

export default SingleSelector;



// WEBPACK FOOTER //
// ./src/components/FormControls/SingleSelector/SingleSelector.tsx